import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { persistor } from "../../../../redux/store";
import * as auth from "../_redux/authRedux";
import { submitLogoutToAuthService } from "../_redux/authCrud";

function Logout({ logout, hasAuthToken, idToken }) {
  const [delegating] = useState(() => Boolean(idToken));
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) {
      return;
    }
    startedRef.current = true;

    if (!delegating) {
      logout();
      return;
    }

    (async () => {
      logout();
      await persistor.flush();
      submitLogoutToAuthService({ idToken });
    })();
  }, [delegating, idToken, logout]);

  if (delegating || hasAuthToken) {
    return <LayoutSplashScreen />;
  }

  return <Redirect to="/auth/login" />;
}

export default connect(
  ({ auth }) => ({
    hasAuthToken: Boolean(auth.authToken),
    idToken: auth.idToken,
  }),
  auth.actions
)(Logout);
